export default {
	code_access_invalid: "Código de acesso inválido.",
	code_access_expired: "Código de acesso expirado."
}
